import React, { useEffect, useState } from 'react';
import appUrl from '../../../../constants/appUrl';

const AgainstProductProcessView = ({ product }) => {
    const [productList, setProductList] = useState([]);

    const GetProcessById = async (productId) => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/Process/GetProcessByProductId/${productId}`);
            const data = await response.json();
            setProductList(data);
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    useEffect(() => {
        if (product && product.productId) {
            GetProcessById(product.productId);
        }
    }, [product]);

    return (
        <div>
            {productList.map((item, index) => (
                <div key={index} className=''>
                    <div className='heading-custom'>
                        <div className='grid'>
                            <div className='md:col-4'>
                                <h5>{item.policyPrefix}</h5>
                            </div>
                            <div className='md:col-4'>
                                <h5>Store 4</h5>
                            </div>
                            <div className='md:col-4'>
                                <h5>{item.createdDate}</h5>
                            </div>
                        </div>
                    </div>
                    <div className='grid'>
                        <div className='md:col-12'>
                            <ul>
                                <li>{item.description}</li> 
                            </ul>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AgainstProductProcessView;
